import { Box, Flex, Hide } from '@galilee/lilee';
import { ItemTitle, InlineText } from "./index";
import styled from 'styled-components';
import { formatCurrency } from 'utils';

const SettlementFeeContainer = styled(Box)`
    display : grid;
    grid-template-rows: 1fr;
    grid-template-columns: 38% 18% 15% auto;
    justify-content: space-between;
    @media screen and (max-width: ${(p) => p.theme.breakpointsMax[4]}) {
        grid-template-columns: 1fr;
    }
`;
const Header = styled(Box)`
    display : grid;
    grid-template-rows: 1fr;
    grid-template-columns: 30% 10% 15% auto;
    justify-content: space-between;
    border-bottom: 1px solid ${(p) => p.theme.colors.base10};
`;
const SettlementFeeDetailsCard = ({ settlementFeeDetails, feeGroup, showDetails}) => {          
    return (
        <>
            <Header mt="3" mb="1">
               <ItemTitle>{feeGroup}</ItemTitle>               
               {showDetails && <Hide breakpoints={[0, 1, 2, 3, 4]}><ItemTitle>BSB</ItemTitle></Hide>} 
               {showDetails && <Hide breakpoints={[0, 1, 2, 3, 4]}><ItemTitle>Account/Ref No</ItemTitle></Hide>} 
            </Header>  
            <Flex flexDirection="column">
                {settlementFeeDetails?.map((settlementFeeDetails, idx) => (
                    <SettlementFeeContainer key={settlementFeeDetails.feeName + idx} mt="2">
                        <Flex alignItems="flex-start" mb="1">                            
                            <InlineText>{settlementFeeDetails.feeName } {settlementFeeDetails.description}</InlineText>
                        </Flex>       
                        <Flex alignItems="flex-start" mb="1"><InlineText>{settlementFeeDetails.bsb }</InlineText></Flex>                                           
                        <Flex alignItems="flex-start" mb="1"><InlineText>{settlementFeeDetails.accountNo }</InlineText></Flex>                        
                        <InlineText alignItems="flex-start">{formatCurrency(settlementFeeDetails.amount)}</InlineText>
                    </SettlementFeeContainer>
                ))}
            </Flex>
        </>
    );
};

export default SettlementFeeDetailsCard;